import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Invite from "@/pages/Invite";
import "@/App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <ContentProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/invitacion/:slug" element={<Invite />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" theme="light" />
      </AuthProvider>
      </ContentProvider>
    </div>
  );
}

export default App;
